import {Component, OnInit} from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';

import {UsefulLinkService} from 'app/services/useful-link.service';
import {UsefulLink} from 'app/models/useful-link';
import {ModalUsefulLinkComponent} from 'app/shared/components/modal-useful-link/modal-useful-link.component';

@Component({
    selector: 'app-useful-links',
    templateUrl: './useful-links.component.html',
    styleUrls: ['./useful-links.component.scss']
})
export class UsefulLinksComponent implements OnInit {

    usefulLinks: Array<UsefulLink>;
    bsModalRef: BsModalRef;
    lastEvaluatedKey: any;

    constructor(private usefulLinkService: UsefulLinkService,
        private modalService: BsModalService) {}

    ngOnInit() {
        this.getAll();
    }

    onAdd() {
        this.showModal(null, 'ADD LINK');
    }

    onEdit(event) {
        this.showModal(event, 'Edit LINK');
    }

    onDelete(event) {
        this.usefulLinkService
            .delete(event.id)
            .subscribe((usefulLinks) => {
                this.getAll();
            });
    }

    getNext() {
        this.getAll(this.lastEvaluatedKey);
    }

    getAll(lastEvaluatedKey?: string): void {
        this.usefulLinkService
            .getAll(lastEvaluatedKey)
            .subscribe((usefulLinks) => {
                this.usefulLinks = this.usefulLinks && lastEvaluatedKey ?
                    this.usefulLinks.concat(usefulLinks.Items) : usefulLinks.Items;
                this.lastEvaluatedKey = usefulLinks.LastEvaluatedKey;

            });
    }
    ngOnDestroy() {
        if (this.bsModalRef)
            this.bsModalRef.content.close.unsubscribe();
    }
    private showModal(usefulLink: UsefulLink, headerTitle: string) {
        this.bsModalRef = this.modalService.show(ModalUsefulLinkComponent, {
            class: 'modal-lg',
            backdrop: 'static'
        });
        if (usefulLink) {
            this.bsModalRef.content.usefulLink = Object.assign({}, usefulLink);
        }

        this.bsModalRef.content.title = headerTitle;
        this.bsModalRef.content.close.subscribe (() => {
            this.getAll();
            this.bsModalRef.hide();
            this.bsModalRef.content.close.unsubscribe();
        });
    }
}
